import { render, staticRenderFns } from "./AnalisiNecessita.vue?vue&type=template&id=6e8a31a4&scoped=true&"
import script from "./AnalisiNecessita.vue?vue&type=script&lang=js&"
export * from "./AnalisiNecessita.vue?vue&type=script&lang=js&"
import style0 from "./AnalisiNecessita.vue?vue&type=style&index=0&id=6e8a31a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a31a4",
  null
  
)

export default component.exports
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QOptionGroup});
